import React, { useState, useEffect, useRef } from "react";
import "./NoreaCRM.css";
import logooficial from "../assets/images/webp/norea.webp";
import printDashboard from "../assets/images/webp/norea-crm-01.webp";
import printDashboardMobile from "../assets/images/webp/norea-crm-01-mobile.webp";
import doctorWhatsapp from "../assets/images/webp/norea-crm-02.webp";
import solutionPrint from "../assets/images/webp/norea-crm-03.webp";



function useLazyAsset(triggerRef, loader) {
  const [asset, setAsset] = useState(null);

  useEffect(() => {
    const element = triggerRef.current;
    if (!element || asset) return;

    let cancelled = false;
    let observer = null;

    const carregarAsset = () => {
      loader()
        .then((modulo) => {
          if (!cancelled) {
            setAsset(modulo.default || modulo);
          }
        })
        .catch((erro) => {
          console.error("Erro ao carregar asset da landing page:", erro);
        });
    };

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            carregarAsset();
            observer.disconnect();
          }
        },
        {
          root: null,
          rootMargin: "300px 0px",
          threshold: 0.01,
        }
      );

      observer.observe(element);
    } else {
      carregarAsset();
    }

    return () => {
      cancelled = true;
      if (observer) observer.disconnect();
    };
  }, [triggerRef, asset]);

  return asset;
}

function NoreaCRM() {


const [menuAberto, setMenuAberto] = useState(false);

const topoRef = useRef(null);
const howRef = useRef(null);
const whatsappRef = useRef(null);
const aiRef = useRef(null);
const adsRef = useRef(null);
const crmRef = useRef(null);
const responsiveRef = useRef(null);

const howItWorksPrint = useLazyAsset(howRef, () => import("../assets/images/webp/norea-crm-04.webp"));

const whatsappFunnelPrint = useLazyAsset(whatsappRef, () => import("../assets/images/webp/norea-crm-05.webp"));
const whatsappBulkPrint = useLazyAsset(whatsappRef, () => import("../assets/images/webp/norea-crm-06.webp"));

const aiPanelPrint = useLazyAsset(aiRef, () => import("../assets/images/webp/norea-crm-10.webp"));
const aiPromptPrint = useLazyAsset(aiRef, () => import("../assets/images/webp/norea-crm-07.mp4"));
const aiRulesPrint = useLazyAsset(aiRef, () => import("../assets/images/webp/norea-crm-08.webp"));
const aiOperationPrint = useLazyAsset(aiRef, () => import("../assets/images/webp/norea-crm-09.webp"));

const adsOverviewPrint = useLazyAsset(adsRef, () => import("../assets/images/webp/norea-crm-12.webp"));
const adsEvolutionPrint = useLazyAsset(adsRef, () => import("../assets/images/webp/norea-crm-15.webp"));
const instagramGrowthPrint = useLazyAsset(adsRef, () => import("../assets/images/webp/norea-crm-13.webp"));

const WomanSecret = useLazyAsset(crmRef, () => import("../assets/images/webp/norea-crm-17.webp"));
const responsiveGif = useLazyAsset(responsiveRef, () => import("../assets/images/webp/norea-crm-18.mp4"));

useEffect(() => {
  if (window.gtag) {
    window.gtag("event", "conversion", {
      send_to: "AW-17876096946/nhUdCJOSnqccELKv_stC",
      value: 1.0,
      currency: "BRL",
      aw_remarketing_only: true,
    });
  }
}, []);

const voltarAoTopo = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (topoRef.current) {
    topoRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  setTimeout(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 80);
};

const checkoutUrl = "/crm-wly/checkout";

const handleCheckoutClick = async (e) => {
  e.preventDefault();

  const eventId = Date.now().toString();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "fb_custom_event",
    event_name: "InitiateCheckout",
    event_id: eventId,
    value: 297,
    currency: "BRL"
  });

  try {
    await fetch("/crm-wly/api/meta/enviar_evento.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        event_name: "InitiateCheckout",
        event_id: eventId,
        valor: 297
      })
    });
  } catch (error) {
    console.error("Erro ao enviar evento CAPI:", error);
  }

  window.location.href = checkoutUrl;
};

  return (
    <main className="norea-page" ref={topoRef} id="topo">
        <title>Nórea CRM | CRM com WhatsApp, Gestão de Leads, IA e Disparos em Massa</title>
<meta
  name="description"
  content="Nórea CRM é uma plataforma completa para gestão de leads, atendimento pelo WhatsApp, disparos em massa, automação comercial, funil de vendas, integração com Meta Ads, Google Ads e agentes de IA."
/>
<meta
  name="keywords"
  content="CRM, CRM para WhatsApp, gestão de leads, disparos em massa, automação de WhatsApp, funil de vendas, atendimento com IA, CRM para tráfego pago, Meta Ads, Google Ads, automação comercial"
/>
      <section className="norea-hero">
        <div className="norea-hero-bg-glow norea-hero-bg-glow-1"></div>
        <div className="norea-hero-bg-glow norea-hero-bg-glow-2"></div>

        <header className="norea-hero-header">
<div className="norea-brand">
<img
  src={logooficial}
  alt="Nórea CRM"
  className="norea-brand-logo"
  width="180"
  height="60"
/>
  <span className="norea-brand-product">CRM</span>
</div>

<button
  type="button"
  className={`norea-menu-toggle ${menuAberto ? "ativo" : ""}`}
  onClick={() => setMenuAberto(!menuAberto)}
  aria-label="Abrir menu"
>
  <span></span>
  <span></span>
  <span></span>
</button>

<nav className={`norea-nav ${menuAberto ? "norea-nav-open" : ""}`}>
  <a onClick={() => setMenuAberto(false)} href="#como-funciona">Como funciona</a>
  <a onClick={() => setMenuAberto(false)} href="#whatsapp">WhatsApp</a>
  <a onClick={() => setMenuAberto(false)} href="#ia">IA</a>
  <a onClick={() => setMenuAberto(false)} href="#resultados">Resultados</a>
  <a onClick={() => setMenuAberto(false)} href="#diferenciais">Diferenciais</a>
  <a onClick={() => setMenuAberto(false)} href="#oferta">Planos</a>
</nav>

          <a className="norea-header-cta" href={checkoutUrl} onClick={handleCheckoutClick}>
            Começar agora
          </a>
        </header>

        <div className="norea-hero-content">
          <div className="norea-hero-copy">
            <div className="norea-hero-badge">
              CRM + WhatsApp + IA + Tráfego Pago
            </div>

            <h1>
              Transforme seu WhatsApp em uma máquina de vendas com inteligência
              artificial.
            </h1>

            <p>
              Centralize seus leads, automatize atendimentos, acompanhe o funil
              de vendas e descubra quais campanhas realmente geram conversas,
              tudo em um só lugar.
            </p>            
          </div>

          <div className="norea-hero-visual">
<div className="norea-real-dashboard">
  <picture>
    <source
      media="(max-width: 680px)"
      srcSet={printDashboardMobile}
    />
    <img
      src={printDashboard}
      alt="Dashboard do Nórea CRM com gestão de leads, WhatsApp, IA e relatórios de tráfego pago"
      width="900"
      height="620"
      fetchPriority="high"
      decoding="async"
      className="norea-hero-dashboard-img"
    />
  </picture>
</div>

            <div className="norea-floating-card norea-floating-card-1">
              <strong>+ conversas</strong>
              <span>com menos esforço</span>
            </div>

            <div className="norea-floating-card norea-floating-card-2">
              <strong>IA ativa</strong>
              <span>respondendo leads</span>
            </div>
                                  <div className="norea-hero-actions">
              <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
                Começar agora
              </a>

              <a href="#como-funciona" className="norea-btn norea-btn-secondary">
                Ver como funciona
              </a>
            </div>

            <div className="norea-hero-points">
              <span>Sem fidelidade</span>
              <span>Ativação rápida</span>
              <span>Multiatendimento</span>
            </div>
          </div>
        </div>
      </section>

 <section className="norea-problem" id="problema">
  <div className="norea-section-container">
    <div className="norea-problem-head">
      <div className="norea-problem-copy">
        <div className="norea-section-eyebrow">O problema</div>

        <h2>
          Seu WhatsApp recebe leads{" "}
          <span>todos os dias</span>, mas você ainda não tem controle real sobre
          as <span>oportunidades.</span>
        </h2>

        <p className="norea-section-subtitle">
          A maioria das empresas não perde venda por falta de interessados. Perde
          porque o atendimento fica espalhado, os retornos atrasam e ninguém sabe
          exatamente de onde vieram os melhores contatos.
        </p>
      </div>

      <div className="norea-problem-image-wrap">
<img
  src={doctorWhatsapp}
  alt="Profissional usando WhatsApp para atendimento e gestão de leads"
  className="norea-problem-image"
  width="390"
  height="500"
  loading="lazy"
/>

<div className="norea-problem-phone-ui">
  <div className="norea-problem-phone-header">
    WhatsApp
    <span>3 leads aguardando</span>
  </div>

  <div className="norea-problem-message">
    <strong>Maria Helena</strong>
    <span>Olá, gostaria de saber valores...</span>
  </div>

  <div className="norea-problem-message norea-problem-message-late">
    <strong>Bruno Silva</strong>
    <span>Sem resposta há 3h</span>
  </div>

  <div className="norea-problem-message">
    <strong>Clínica Vida</strong>
    <span>Veio do Instagram Ads</span>
  </div>
</div>

<div className="norea-problem-alert">
  <strong>Lead sem retorno</strong>
  <span>oportunidade esfriando</span>
</div>
      </div>
    </div>

    <div className="norea-problem-grid">
      <div className="norea-problem-card">
        <span>01</span>
        <h3>Leads se perdem no WhatsApp</h3>
        <p>
          Conversas importantes ficam misturadas, sem histórico organizado, sem
          etapa de funil e sem acompanhamento comercial.
        </p>
      </div>

      <div className="norea-problem-card">
        <span>02</span>
        <h3>Equipe sem visão do atendimento</h3>
        <p>
          Quando várias pessoas atendem pelo WhatsApp, fica difícil saber quem
          respondeu, quem ficou sem retorno e qual lead precisa de atenção.
        </p>
      </div>

      <div className="norea-problem-card">
        <span>03</span>
        <h3>Campanhas gerando custo sem clareza</h3>
        <p>
          Você investe em Meta Ads e Google Ads, mas nem sempre consegue saber
          quais campanhas realmente geram conversas e oportunidades.
        </p>
      </div>

      <div className="norea-problem-card">
        <span>04</span>
        <h3>Follow-up feito no improviso</h3>
        <p>
          Sem ações, lembretes, tags e automações, muitos leads interessados
          esfriam antes de virar cliente.
        </p>
      </div>
    </div>
  </div>
</section>



<section className="norea-solution" id="solucao">
  <div className="norea-section-container">
    <div className="norea-solution-head">
      <div className="norea-solution-print">
        <img
          src={solutionPrint}
          alt="Tela do Nórea CRM com atendimento pelo WhatsApp, leads e funil de vendas"
          width="1200"
          height="800"
          loading="lazy"
        />
      </div>

      <div className="norea-solution-title">
        <div className="norea-section-eyebrow norea-section-eyebrow-blue">
          A solução
        </div>

        <h2>
  O Nórea CRM conecta seu{" "}
  <span>WhatsApp</span>, seus{" "}
  <span>leads</span>, sua{" "}
  <span>equipe</span> e seus{" "}
  <span>anúncios</span> em um único lugar.
</h2>
      </div>
    </div>

    <p className="norea-solution-subtitle">
      Em vez de perder oportunidades no WhatsApp, sua empresa passa a centralizar
      leads, atendimento, equipe, automações, IA e relatórios em uma operação
      simples de acompanhar e fácil de escalar.
    </p>

    <div className="norea-solution-flow">
      <div className="norea-flow-line norea-flow-line-1"></div>
      <div className="norea-flow-line norea-flow-line-2"></div>
      <div className="norea-flow-line norea-flow-line-3"></div>
      <div className="norea-flow-line norea-flow-line-4"></div>

      <div className="norea-solution-node norea-solution-node-1">
        <strong>WhatsApp</strong>
        <small>atendimento centralizado</small>
      </div>

      <div className="norea-solution-node norea-solution-node-2">
        <strong>Leads</strong>
        <small>cadastro, origem e histórico</small>
      </div>

      <div className="norea-solution-center-card">
        <span>Nórea</span>
        <strong>CRM</strong>
        <small>central de vendas</small>
      </div>

      <div className="norea-solution-node norea-solution-node-3">
        <strong>Equipe</strong>
        <small>multiatendimento sem bagunça</small>
      </div>

      <div className="norea-solution-node norea-solution-node-4">
        <strong>Anúncios</strong>
        <small>Meta Ads e Google Ads</small>
      </div>
    </div>

    <div className="norea-solution-benefits">
      <div className="norea-solution-benefit">
        <span>01</span>
        <h3>Histórico completo do lead</h3>
        <p>
          Cada conversa fica vinculada ao contato, com origem, tags, etapa do
          funil, observações e todo o histórico de atendimento.
        </p>
      </div>

      <div className="norea-solution-benefit">
        <span>02</span>
        <h3>Atendimento compartilhado</h3>
        <p>
          Sua equipe pode responder pelo mesmo WhatsApp dentro do CRM, mantendo
          organização, contexto e controle das oportunidades.
        </p>
      </div>

      <div className="norea-solution-benefit">
        <span>03</span>
        <h3>Decisão baseada em dados</h3>
        <p>
          Veja quais origens, campanhas e canais geram conversas reais, CPL mais
          baixo e oportunidades com mais chance de venda.
        </p>
      </div>

      <div className="norea-solution-benefit">
        <span>04</span>
        <h3>Rotina comercial automatizada</h3>
        <p>
          Use ações, respostas rápidas, agendamentos, disparos, tags e IA para
          acelerar retornos e reduzir esquecimentos.
        </p>
      </div>
    </div>
  </div>
  <div className="norea-solution-cta">
  <div>
    <strong>Pronto para organizar seus leads?</strong>
    <span>Veja como o Nórea CRM pode centralizar sua operação comercial.</span>
  </div>

  <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
    Começar agora
  </a>
</div>
</section>


<section className="norea-how" id="como-funciona" ref={howRef}>
  <div className="norea-section-container">
    <div className="norea-how-head">
      <div>
        <div className="norea-section-eyebrow">Como funciona</div>

<h2>
  Veja como um{" "}
  <span>lead</span> vira uma{" "}
  <span>oportunidade</span> dentro do Nórea CRM.
</h2>


      </div>

      <p>
        Tudo acontece dentro de uma única tela: o lead chega pelo anúncio, entra
        na conversa, ganha origem, histórico, etapa de funil e pode ser atendido
        pela equipe ou pela IA.
      </p>
    </div>

    <div className="norea-how-visual">
      {howItWorksPrint && (
      <img
        src={howItWorksPrint}
        alt="Tela do Nórea CRM mostrando WhatsApp, origem do lead, funil de vendas e atendimento com IA"
          width="1200"
          height="800"
          loading="lazy"
        decoding="async"
      />
      )}

      <div className="norea-micro-label norea-label-1">
        <strong>Lead chegou pelo anúncio</strong>
        <span>Miniatura do anúncio aparece</span>
      </div>

      <div className="norea-micro-label norea-label-2">
        <strong>Origem reconhecida</strong>
        <span>Identificado no CRM</span>
      </div>

      <div className="norea-micro-label norea-label-3">
        <strong>Funil atualizado</strong>
        <span>lead evolui por etapa</span>
      </div>

      <div className="norea-micro-label norea-label-4">
        <strong>IA ou equipe responde</strong>
        <span>atendimento organizado</span>
      </div>

      <div className="norea-micro-label norea-label-5">
        <strong>Conversas centralizadas</strong>
        <span>vários leads em uma tela</span>
      </div>
    </div>

    <div className="norea-how-steps">
      <div className="norea-how-step">
        <span>01</span>
        <h3>Conecte seu WhatsApp</h3>
        <p>
          Sua operação começa com o WhatsApp integrado ao CRM, pronto para
          receber e responder conversas.
        </p>
      </div>

      <div className="norea-how-step">
        <span>02</span>
        <h3>Receba leads automaticamente</h3>
        <p>
          Novos contatos chegam com histórico, origem, conversa e dados
          importantes para o atendimento.
        </p>
      </div>

      <div className="norea-how-step">
        <span>03</span>
        <h3>Atenda com equipe ou IA</h3>
        <p>
          Use multiatendimento, respostas rápidas, tags, ações e agente de IA
          para acelerar retornos.
        </p>
      </div>

      <div className="norea-how-step">
        <span>04</span>
        <h3>Acompanhe e venda mais</h3>
        <p>
          Controle funil, origem, ações, anúncios, CPL e oportunidades para
          tomar decisões melhores.
        </p>
      </div>
    </div>

    <div className="norea-how-cta">
      <strong>Quer ver esse fluxo funcionando no seu negócio?</strong>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
        Começar agora
      </a>
    </div>
  </div>
</section>

<section className="norea-whatsapp" id="whatsapp" ref={whatsappRef}>
  <div className="norea-section-container">

    {/* HEAD */}
    <div className="norea-whatsapp-head">
      <div className="norea-section-eyebrow norea-section-eyebrow-whatsapp">
        WhatsApp em escala
      </div>

      <h2>
        Transforme seu WhatsApp em uma{" "}
        <span>máquina de conversão previsível.</span>
      </h2>

      <p>
        Organize leads em funis, automatize follow-ups e envie mensagens em massa
        com controle total — tudo dentro do Nórea CRM.
      </p>
    </div>

    {/* PRINT 1 — FUNIL */}
    <div className="norea-whatsapp-print">
      {whatsappFunnelPrint && (
      <img
        src={whatsappFunnelPrint}
        alt="Funil de mensagens do Nórea CRM"
        width="1200"
        height="600"
        loading="lazy"
        decoding="async"
      />
      )}
    </div>

    {/* CARDS */}
    <div className="norea-whatsapp-cards">

      <div className="norea-whatsapp-card">
        <span>01</span>
        <h3>Funil de mensagens</h3>
        <p>
          Organize seus leads por etapa e acompanhe cada conversa até a
          conversão com total clareza.
        </p>
      </div>

      <div className="norea-whatsapp-card">
        <span>02</span>
        <h3>Follow-up automático</h3>
        <p>
          Programe mensagens e nunca mais esqueça de responder um lead
          interessado.
        </p>
      </div>

      <div className="norea-whatsapp-card">
        <span>03</span>
        <h3>Disparo em massa</h3>
        <p>
          Envie mensagens para vários contatos ao mesmo tempo com organização e
          segurança.
        </p>
      </div>

      <div className="norea-whatsapp-card">
        <span>04</span>
        <h3>Controle total da operação</h3>
        <p>
          Pause, retome e ajuste envios sempre que precisar sem perder o
          contexto dos leads.
        </p>
      </div>

    </div>

    {/* PRINT 2 — DISPARO / AGENDAMENTO */}
<div className="norea-whatsapp-print norea-whatsapp-print-second">
  {whatsappBulkPrint && (
  <img
    src={whatsappBulkPrint}
    alt="Disparo em massa e agendamento de mensagens no Nórea CRM"
    decoding="async"
  />
  )}

  <div className="norea-whatsapp-label-agendamento">
    <strong>Agendamento inteligente</strong>
    <span>envie mensagens no dia e horário certos</span>
  </div>
</div>

    {/* CTA */}
    <div className="norea-whatsapp-cta">
      <div>
        <strong>Seu WhatsApp pode vender muito mais.</strong>
        <span>
          Estruture seu atendimento e escale suas conversas com o Nórea CRM.
        </span>
      </div>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
        Começar agora
      </a>
    </div>

  </div>
</section>

<section className="norea-ai" id="ia" ref={aiRef}>
  <div className="norea-section-container">
    <div className="norea-ai-hero">
      <div className="norea-ai-copy">
        <div className="norea-section-eyebrow norea-section-eyebrow-ai">
          Inteligência Artificial
        </div>

        <h2>
          Uma IA que não só responde, mas{" "}
          <span>converte, filtra e decide com você.</span>
        </h2>

        <p>
          Configure como a IA deve agir, quando responder, quando transferir para
          um humano e como conduzir cada conversa dentro do seu processo
          comercial.
        </p>

        <div className="norea-ai-highlights">
          <div>
            <strong>Treinada no seu negócio</strong>
            <span>prompt, contexto, produtos e exceções</span>
          </div>

          <div>
            <strong>Controle humano</strong>
            <span>handoff automático quando necessário</span>
          </div>

          <div>
            <strong>Atendimento estratégico</strong>
            <span>mais velocidade sem perder qualidade</span>
          </div>
        </div>
      </div>

      <div className="norea-ai-main-print">
        {aiPanelPrint && (
        <img
          src={aiPanelPrint}
          alt="Painel de Inteligência Artificial do Nórea CRM"
          width="900"
height="600"
loading="lazy"
          decoding="async"
        />
        )}

        <div className="norea-ai-floating">
          <strong>IA configurável</strong>
          <span>do jeito que seu negócio precisa</span>
        </div>
      </div>
    </div>

    <div className="norea-ai-layers">
      <div className="norea-ai-layer">
        <div className="norea-ai-layer-text">
          <span>01</span>
          <h3>IA treinada no seu negócio</h3>
          <p>
            Defina contexto, objetivos, catálogo, scripts e exceções. A IA passa
            a responder com base na realidade da sua empresa, não com respostas
            genéricas.
          </p>
        </div>

        <div className="norea-ai-layer-print">
          {aiRulesPrint && (
          <img
            src={aiRulesPrint}
            alt="Regras inteligentes da IA no Nórea CRM"          
            width="900"
height="600"
loading="lazy"
            decoding="async"
          />
          )}
        </div>
      </div>

      <div className="norea-ai-layer norea-ai-layer-reverse">
        <div className="norea-ai-layer-text">
          <span>02</span>
          <h3>Regras inteligentes de decisão</h3>
          <p>
            Defina quando a IA pode ou não responder um lead, mantendo controle total sobre cada atendimento.
          </p>
        </div>

        <div className="norea-ai-layer-print">
{aiPromptPrint && (
<video
  src={aiPromptPrint}
  autoPlay
  loop
  muted
  playsInline
  preload="none"
  className="norea-video norea-video-ai-prompt"
/>
)}
        </div>
      </div>

      <div className="norea-ai-layer">
        <div className="norea-ai-layer-text">
          <span>03</span>
          <h3>Controle total da operação</h3>
          <p>
            Ative, desative, coloque em modo treinamento, limite respostas e
            acompanhe o comportamento da IA antes de liberar para todos os leads.
          </p>
        </div>

        <div className="norea-ai-layer-print">
          {aiOperationPrint && (
          <img
            src={aiOperationPrint}
            alt="Operação geral da IA no Nórea CRM"
              width="700"
              height="400"
            loading="lazy"
            decoding="async"
          />
          )}
        </div>
      </div>
    </div>

    <div className="norea-ai-cta">
      <div>
        <strong>Sua equipe pode atender melhor. Sua IA pode atender por você.</strong>
        <span>
          Transforme atendimento em processo, velocidade e conversão.
        </span>
      </div>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
        Começar agora
      </a>
    </div>
  </div>
</section>

<section className="norea-ads" id="resultados" ref={adsRef}>
  <div className="norea-section-container">
    <div className="norea-ads-head">
      <div>
        <div className="norea-section-eyebrow norea-section-eyebrow-ads">
          Resultados Ads
        </div>

        <h2>
          Pare de investir no escuro. Descubra quais campanhas geram{" "}
          <span>conversas, leads e oportunidades.</span>
        </h2>
      </div>

      <p>
        Com o Nórea CRM, cada clique, conversa e lead vira dado claro para tomada
        de decisão. Você acompanha investimento, CPL, alcance, conversas
        iniciadas e crescimento do público em um só lugar.
      </p>
    </div>

    <div className="norea-ads-main">
      {adsOverviewPrint && (
      <img
        src={adsOverviewPrint}
        alt="Visão geral de resultados de anúncios no Nórea CRM com CPL, investimento, alcance e conversas iniciadas"
        width="1200"
        height="800"
        loading="lazy"
        decoding="async"
      />
      )}
<span className="norea-ads-connector norea-ads-connector-1"></span>
<div className="norea-ads-kpi-row">
  <div className="norea-ads-kpi norea-ads-kpi-1">
    <span className="norea-ads-kpi-dot"></span>
    <strong>91</strong>
    <small>conversas iniciadas</small>
  </div>

  <div className="norea-ads-kpi norea-ads-kpi-2">
    <span className="norea-ads-kpi-dot"></span>
    <strong>R$ 6,60</strong>
    <small>Custo por Lead médio</small>
  </div>

  <div className="norea-ads-kpi norea-ads-kpi-3">
    <span className="norea-ads-kpi-dot"></span>
    <strong>R$ 600,32</strong>
    <small>investidos com controle</small>
  </div>
</div>
    </div>

    <div className="norea-ads-insights">
      <div className="norea-ads-insight-copy">
        <span>01</span>
        <h3>Veja a evolução diária das campanhas</h3>
        <p>
          Acompanhe alcance, investimento e CPL por dia para entender quando sua
          verba performa melhor e onde ajustar sua estratégia.
        </p>
      </div>

      <div className="norea-ads-print-card">
        {adsEvolutionPrint && (
        <img
          src={adsEvolutionPrint}
          alt="Gráfico de evolução diária de alcance, CPL e investimento no Nórea CRM"
            width="1200"
            height="700"
          loading="lazy"
          decoding="async"
        />
        )}
      </div>
    </div>

    <div className="norea-ads-instagram">
      <div className="norea-ads-print-card">
        {instagramGrowthPrint && (
        <img
          src={instagramGrowthPrint}
          alt="Gráfico de seguidores ganhos por dia no Instagram dentro do Nórea CRM"
                      width="1200"
            height="700"
          loading="lazy"
          decoding="async"
        />
        )}
      </div>

      <div className="norea-ads-insight-copy">
        <span>02</span>
        <h3>Muito além dos anúncios: acompanhe o crescimento do público</h3>
        <p>
          O Nórea também mostra a evolução diária de seguidores no Instagram,
          ajudando você a entender não só quem compra, mas quem está entrando no
          universo da sua marca.
        </p>
      </div>
    </div>

    <div className="norea-ads-benefits">
      <div className="norea-ads-benefit">
        <h3>Clareza total</h3>
        <p>Saiba exatamente de onde vêm seus leads e quais canais geram conversas.</p>
      </div>

      <div className="norea-ads-benefit">
        <h3>Decisão rápida</h3>
        <p>Invista mais no que funciona e reduza verba no que não traz resultado.</p>
      </div>

      <div className="norea-ads-benefit">
        <h3>Crescimento previsível</h3>
        <p>Acompanhe métricas reais para transformar tráfego em vendas com mais controle.</p>
      </div>
    </div>

    <div className="norea-ads-cta">
      <div>
        <strong>Toque no botão e comece a enxergar seus resultados com clareza.</strong>
        <span>Controle campanhas, conversas e crescimento em um só painel.</span>
      </div>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
        Quero controlar meus anúncios
      </a>
    </div>
  </div>
</section>

<section className="norea-crm" ref={crmRef}>
  <div className="norea-container">

    <div className="norea-crm-grid">

      {/* IMAGEM */}
      <div className="norea-crm-image-wrap">
        <div className="norea-crm-image-wrapper">

        {WomanSecret && (
        <img
          src={WomanSecret}
          alt="Atendentes não sobrecarregados"
          className="norea-crm-image"
          width="700"
          height="700"
          loading="lazy"
          decoding="async"
        />
        )}      </div>
</div>
      {/* CONTEÚDO */}
      <div className="norea-crm-content">

        <span className="norea-badge">CRM</span>

        <h2>
          Pare de gerenciar <span>conversas</span>.
          <br />
          Comece a controlar um <span>processo comercial</span>.
        </h2>

        <p>
          O Nórea transforma cada lead em um fluxo organizado, com histórico,
          etapa, origem e próximos passos claros para sua equipe.
        </p>

        {/* MINI CARDS */}
        <div className="norea-crm-features">

          <div className="norea-crm-feature">
            <strong>Funil visível</strong>
            <span>cada lead na etapa certa</span>
          </div>

          <div className="norea-crm-feature">
            <strong>Segmentação</strong>
            <span>tags e organização inteligente</span>
          </div>

          <div className="norea-crm-feature">
            <strong>Histórico</strong>
            <span>tudo registrado automaticamente</span>
          </div>

          <div className="norea-crm-feature">
            <strong>Origem</strong>
            <span>de onde veio cada oportunidade</span>
          </div>

        </div>

        {/* MINI FLUXO */}
        <div className="norea-crm-flow">
          <span>Lead</span>
          <span></span>
          <span>Qualificação</span>
          <span></span>
          <span>Follow-up</span>
          <span></span>
          <span>Cliente</span>
        </div>

      </div>

    </div>

  </div>
</section>

<section className="norea-audience">
  <div className="norea-section-container">
    <span className="norea-section-eyebrow">Para quem é</span>

    <h2 className="norea-audience-title">
      Feito para quem precisa <span>vender mais</span>,<br />
      não apenas responder mensagens.
    </h2>

    <p className="norea-section-subtitle">
      Se você depende de WhatsApp, leads, anúncios ou relacionamento comercial,
      o Nórea não é opcional — é estrutura.
    </p>

    <div className="norea-audience-grid">
      <div className="norea-audience-card highlight">
        <div className="norea-audience-icon norea-icon-traffic">
          <i></i>
        </div>
        <strong>Se você trabalha com tráfego pago</strong>
        <span>
          acompanhe campanhas, conversas, CPL e oportunidades sem depender de
          planilhas ou prints soltos.
        </span>
      </div>

      <div className="norea-audience-card">
        <div className="norea-audience-icon norea-icon-leads">
          <i></i>
        </div>
        <strong>Se você capta leads todos os dias</strong>
        <span>
          organize contatos, origem, etapa do funil e próximos passos dentro de
          uma única operação.
        </span>
      </div>

      <div className="norea-audience-card">
        <div className="norea-audience-icon norea-icon-whatsapp">
          <i></i>
        </div>
        <strong>Se seu atendimento acontece no WhatsApp</strong>
        <span>
          centralize conversas, equipe, histórico, tags e acompanhamento sem
          perder oportunidades.
        </span>
      </div>

      <div className="norea-audience-card">
        <div className="norea-audience-icon norea-icon-broadcast">
          <i></i>
        </div>
        <strong>Se você dispara promoções ou avisos</strong>
        <span>
          envie mensagens em massa, agende comunicações e mantenha controle sobre
          cada envio.
        </span>
      </div>

      <div className="norea-audience-card highlight">
        <div className="norea-audience-icon norea-icon-client">
          <i></i>
        </div>
        <strong>Se você mede resultado para clientes</strong>
        <span>
          entregue relatórios mais claros, mostre números reais e prove o valor
          do seu trabalho.
        </span>
      </div>

      <div className="norea-audience-card norea-audience-not">
        <div className="norea-audience-icon norea-icon-not">
          <i></i>
        </div>
        <strong>Não é para você</strong>
        <span>
          se você não quer organizar leads, não acompanha vendas e prefere
          continuar dependendo do improviso.
        </span>
      </div>
    </div>
  </div>
</section>


<section className="norea-differentials" id="diferenciais">
  <div className="norea-section-container">
    <div className="norea-differentials-head">
      <span className="norea-section-eyebrow norea-section-eyebrow-blue">
        Diferenciais
      </span>

      <h2>
        Você não precisa de mais ferramentas. Precisa de um sistema que{" "}
        <span>conecte tudo.</span>
      </h2>

      <p className="norea-section-subtitle">
        O Nórea CRM une atendimento, leads, WhatsApp, IA, relatórios e tráfego pago
        em uma operação simples de acompanhar e fácil de escalar.
      </p>
    </div>

    <div className="norea-differentials-grid">
      <div className="norea-differential-card">
        <div className="norea-differential-icon norea-diff-icon-all"><i></i></div>
        <strong>Tudo em um só lugar</strong>
        <span>CRM, WhatsApp, IA, funil, tags, ações e relatórios sem precisar trocar de ferramenta.</span>
      </div>

      <div className="norea-differential-card">
        <div className="norea-differential-icon norea-diff-icon-whatsapp"><i></i></div>
        <strong>WhatsApp de verdade</strong>
        <span>Sua equipe atendendo no mesmo número, com histórico, controle e acompanhamento.</span>
      </div>

      <div className="norea-differential-card">
        <div className="norea-differential-icon norea-diff-icon-ai"><i></i></div>
        <strong>IA que atende com contexto</strong>
        <span>Não é bot engessado. A IA entende regras, conversa e sabe quando transferir.</span>
      </div>

      <div className="norea-differential-card norea-differential-featured">
        <div className="norea-differential-icon norea-diff-icon-ads"><i></i></div>
        <strong>Tráfego conectado ao comercial</strong>
        <span>Veja quais campanhas geram conversas, leads e oportunidades reais dentro do CRM.</span>
      </div>

      <div className="norea-differential-card">
        <div className="norea-differential-icon norea-diff-icon-users"><i></i></div>
        <strong>Sem limite de usuários</strong>
        <span>Cresça sua equipe sem pagar mais por cada pessoa que precisa atender.</span>
      </div>

      <div className="norea-differential-card">
        <div className="norea-differential-icon norea-diff-icon-free"><i></i></div>
        <strong>Sem fidelidade</strong>
        <span>Você fica porque o sistema funciona, não porque está preso em contrato.</span>
      </div>
    </div>

    <div className="norea-differentials-result">
      <strong>Resultado prático:</strong>
      <span>menos improviso, mais controle sobre os leads e mais previsibilidade de vendas.</span>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-btn norea-btn-primary">
        Começar agora
      </a>
    </div>
  </div>
</section>

<section className="norea-responsive" ref={responsiveRef}>
  <div className="norea-section-container">
    <h2 className="norea-responsive-title">
      E ainda é <span>RESPONSIVO</span>
    </h2>

    <p className="norea-responsive-sub">
      Funciona perfeitamente no celular, tablet ou computador.
      Sua operação não para.
    </p>

    <div className="norea-responsive-media">
{responsiveGif && (
<video
  src={responsiveGif}
  autoPlay
  loop
  muted
  playsInline
  preload="none"
  className="norea-video norea-video-responsive"
/>
)}
    </div>
  </div>
</section>


<section className="norea-offer" id="oferta">
  <div className="norea-section-container">

    <span className="norea-section-eyebrow norea-section-eyebrow-green">
      Oferta
    </span>

    <h2 className="norea-offer-title">
      Comece a organizar seu comercial <span>HOJE</span>.
    </h2>

    <p className="norea-offer-sub">
      Sem fidelidade. Sem burocracia. Você começa a usar agora e cancela quando quiser.
    </p>

    <div className="norea-offer-card">

<div className="norea-offer-price-box">
  <span className="norea-offer-old-price">De R$ 527/mês</span>

  <div className="norea-offer-price">
    <span className="norea-offer-currency">R$</span>
    <strong>297</strong>
    <span className="norea-offer-period">/mês</span>
  </div>

  <span className="norea-offer-discount">Oferta de lançamento</span>
</div>

      <ul className="norea-offer-benefits">
        <li>CRM completo com funil e gestão de leads</li>
        <li>WhatsApp integrado com múltiplos atendentes</li>
        <li>IA para atendimento automático</li>
        <li>Disparos em massa e agendamento de mensagens</li>
        <li>Relatórios de tráfego Meta e Google</li>
      </ul>

      <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-offer-button">
        Começar agora
      </a>

      <span className="norea-offer-note">
        Você começa a usar em minutos.
      </span>

    </div>

  </div>
</section>

<section className="norea-faq">
  <div className="norea-section-container">

    <span className="norea-section-eyebrow">
      Dúvidas frequentes
    </span>

    <h2 className="norea-faq-title">
      Tudo que você precisa saber antes de começar
    </h2>

    <div className="norea-faq-list">

      <div className="norea-faq-item">
        <strong>Preciso instalar algo?</strong>
        <p>Não. O Nórea CRM é 100% online. Você acessa de qualquer lugar, direto pelo navegador.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Funciona com meu número atual?</strong>
        <p>Sim. Você conecta seu WhatsApp atual e continua usando normalmente, sem perder conversas.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Posso usar com minha equipe?</strong>
        <p>Sim. Você pode ter múltiplos acessos ao mesmo WhatsApp, sem limite de usuários.</p>
      </div>

      <div className="norea-faq-item">
        <strong>A IA responde sozinha?</strong>
        <p>Sim. Você define regras e ela responde automaticamente, ou pode usar junto com sua equipe.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Tem fidelidade?</strong>
        <p>Não. Você pode cancelar quando quiser, sem multas ou contratos longos.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Posso agendar mensagens?</strong>
        <p>Sim. Você agenda envios para qualquer data e horário, direto pelo sistema.</p>
      </div>

      <div className="norea-faq-item highlight">
        <strong>O CRM vai medir só a partir do momento que eu conectar minha conta de anúncios?</strong>
        <p>
          Não. Como a integração é feita direto pela API oficial do Meta, o Nórea consegue puxar dados retroativos das campanhas.
          <br /><br />
          A única exceção é o número de seguidores, que passa a ser acompanhado a partir da ativação dentro do próprio CRM.
        </p>
      </div>

      <div className="norea-faq-item">
        <strong>Preciso entender de tecnologia para usar?</strong>
        <p>Não. O sistema foi feito para ser simples e intuitivo. Em poucos minutos você já consegue usar.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Consigo acompanhar meus resultados em tempo real?</strong>
        <p>Sim. Você vê cliques, conversas, custo por lead e desempenho das campanhas atualizados automaticamente.</p>
      </div>

      <div className="norea-faq-item">
        <strong>Posso disparar mensagens em massa?</strong>
        <p>Sim. Com controle de fila, delay entre envios e personalização por lead.</p>
      </div>


      <div className="norea-faq-item">
    <strong>
        Se por algum motivo o WhatsApp banir ou suspender meu número, perco todas as minhas conversas e leads?
    </strong>
    <p>
        Não. Seus dados continuam seguros no sistema. Todo o histórico permanece salvo no Nórea CRM.
        <br /><br />
        Basta conectar um novo número de WhatsApp e tudo volta a funcionar normalmente.
        <br /><br />
        A única observação é que o lead passará a conversar com um novo número, mas você mantém todo o histórico anterior.
    </p>
    </div>



    </div>

  </div>
</section>


<section className="norea-cta-final" id="cta-final">
  <div className="norea-cta-container">

    <h2>
      Transforme seu WhatsApp em uma <span>máquina de vendas</span>.
    </h2>

    <p>
      Organize seus leads, acompanhe suas oportunidades e pare de perder vendas
      por desorganização.
    </p>

    <a href={checkoutUrl} onClick={handleCheckoutClick} className="norea-cta-button">
      Começar agora
    </a>

    <span className="norea-cta-note">
      Comece em minutos • Sem fidelidade • Cancele quando quiser
    </span>

  </div>
</section>

<button
  type="button"
  className="norea-scroll-top"
  onClick={(e) => voltarAoTopo(e)}
  aria-label="Voltar ao topo"
>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M7 14l5-5 5 5"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
</button>

<footer className="norea-footer">
  <div className="norea-section-container">

    <div className="norea-footer-line"></div>

    <p className="norea-footer-text">
      © 2026 Nórea Marketing Especializado e Audiovisual LTDA. Todos os direitos reservados.
    </p>

    <span className="norea-footer-sub">
  Desenvolvido para empresas que levam vendas a sério.
</span>

  </div>
</footer>



    </main>
  );
}

export default NoreaCRM;